module.exports = __webpack_public_path__ + "assets/not-approved.svg?v=a41bcd25f9c7f5b31ee72789349f2810";